import { render } from "./StatisticsOverview.vue?vue&type=template&id=6d7d4c8e&scoped=true"
import script from "./StatisticsOverview.vue?vue&type=script&lang=js"
export * from "./StatisticsOverview.vue?vue&type=script&lang=js"

import "./StatisticsOverview.vue?vue&type=style&index=0&id=6d7d4c8e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7d4c8e"]])

export default __exports__